import CardsWidget from './CardsWidget'
import ColumnsWidget from './ColumnsWidget'
import DonutWidget from './DonutWidget'
import LineCardWidget from './AdminWidget/LineCardWidget'
import TableListDynamic from './TableListDynamic'

/*
  web_type: cards_widget
  details: [
    {
      name: string
      value: number
      formatted_value: string
      icon: string
    },
    ...
  ]
  web_type: bars_widget
  details: {
    bar: [
      {
        name: string,
        value: number,          (eg total_amount)
        value_formatted: string,
        value2: number,         (eg total_orders)
        value2_formatted: string,
      }
      ... 11 others
    ],
    total: [
      {
        name: string,
        value: number,
        value_formatted: string,
      }
    ]
  }
  web_type: donut_widget
  details: {
    chart: [
      {
        name: string,
        value: number,          (eg total_amount)
        value_formatted: string,
        value2: number,         (eg total_orders)
        value2_formatted: string,
      }
      ... 11 others
    ],
    total: [
      {
        name: string,
        value: number,
        value_formatted: string,
      }
    ]
  }

  web_type: donut_widget
  details: {
    donut: {
      {
        name: string,
        value: number,            (eg total_amount)
        value_formatted: string,
        value2: number,           (eg total_orders)
        value2_formatted: string,
      }
      ...
    },
    total: [
      {
        name: string,             (eg Total Orders)
        value: number,
        value_formatted: string,
      }
    ]
  }
*/

export const chartThemeColors = [
  '#0A8D6E',
  '#27CCAA',
  '#80B97D',
  '#72A247',
  '#0d98ba',
  '#24b848',
  '#1d4e54',
  '#E81A43',
  '#50808E',
  '#6fb7bd',
  '#676767',
  '#F08293',
  '#40e0d0',
  '#FFFF00',
  '#9F2B68',
  '#800020',
  '#5D3FD3',
  '#F4B400',
  '#CD7F32',
  '#7B3F00'
]

export const chartThemeColorsLine = [
  '#d41414',
  '#de5a5a',
  '#0A8D6E',
]

export const chartThemeColorsArea = [
  '#ce0b1e',
  '#fd9292'
]

export const chartThemeColorsBar = [
  '#4285F4', // Google Blue
  '#EA4335', // Google Red
  '#FBBC05', // Google Yellow
  '#34A853', // Google Green
  '#00FFFF', // Neon Cyan
  '#FF00FF', // Neon Magenta
  '#FF5E00', // Neon Orange
  '#8A2BE2', // Neon Purple
  '#39FF14', // Neon Lime
  '#FF1493', // Neon Pink
]

export const chartThemeColorsNeon = [
  '#4285F4', // Google Blue
  '#EA4335', // Google Red
  '#FBBC05', // Google Yellow
  '#34A853', // Google Green
  '#9C27B0', // Material Purple
  '#00BCD4', // Material Cyan
  '#FF9800', // Material Orange
  '#E91E63', // Material Pink
  '#3F51B5', // Material Indigo
  '#8BC34A', // Material Light Green
  '#FF5722', // Material Deep Orange
  '#607D8B', // Material Blue Grey
  '#00FFFF', // Electric Cyan
  '#FF00FF', // Electric Magenta
  '#FFFF00', // Bright Lemon Yellow
  '#FF3131', // Neon Red
  '#00FF00', // Electric Lime
  '#FF5E00', // Neon Orange
  '#BF00FF', // Electric Purple
  '#00FFEF', // Neon Turquoise
  '#BFFF00', // Bitter Lemon
  '#FF0055', // Neon Rose
  '#00E5FF', // Cyan Accent
  '#D500F9', // Purple Accent
]

export const chartThemeVerticalBar = [
  '#0A8D6E',
]

export const chartThemeColorsDonut = [
  '#50808E',
  '#0d98ba',
  '#40e0d0',
  "#CD7F32", 
  '#676767',
  '#5D3FD3',
  '#F08293',
  '#800020',
  '#F4B400',
  '#72A247',
  '#F4B400',
  '#9F2B68',
]

export const chartThemeColorsRadial = [
  '#27CCAA',
  '#80B97D',
  '#0d98ba',
  '#676767',
]

export const chartThemeColorsWeek = [
  '#80B97D', 
  '#0d98ba',  
  '#9F2B68',
  "#CD7F32", 
  '#40e0d0', 
  '#50808E', 
  '#0A8D6E',
];

export const chartThemeThresholds = [
  "#19a464",
  "#f0a03e",
  "#e84040"
]

export const chartTableBgColor = [
  "#1ec97a0f",
  "#f0a03e0f",
  "#e840400f"
]

export {
  CardsWidget,
  ColumnsWidget,
  DonutWidget,
  LineCardWidget,
  TableListDynamic
}